if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.variantInfoRequestId = 0;
      this.variantInfoAbortController = null;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      this.hideVariants = this.dataset.hideVariants === 'true';

      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.initDepositOptionCards();
    }

    onVariantChange(e) {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();

      this.updateMediaFromInput(e);
      this.renderVariantInfo();

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateMediaFromInput(e) {
      if (!e || !e.target) return;
      const input = e.target.closest('input, select, option') || e.target;
      let mediaId;
      if (input.tagName === 'SELECT') {
        const selected = input.selectedOptions[0];
        mediaId = selected && selected.dataset.featuredMediaId;
      } else {
        mediaId = input.dataset.featuredMediaId;
      }
      if (!mediaId) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${mediaId}`,
        `#Thumb-${this.dataset.section}-${mediaId}`,
        this.productSlider,
        thumbnails
      );
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`) || this.querySelector(`[data-selected-variant-section="${this.dataset.section}"]`);
      if (!span) return;
      this.currentVariant = {
        id: parseInt(span.dataset.variantId, 10) || null,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
      };
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      const selectedVariantCard = this.querySelector('input[data-value-ids]:checked');
      if (selectedVariantCard && this.other.length) {
        const selectedValueIds = this.getSelectedValueIds();

        this.other.forEach((selector) => {
          selectedValueIds.forEach((valueId) => {
            const localEl = selector.querySelector(`[data-value-id="${valueId}"]`);
            if (!localEl) return;

            if (localEl.tagName === 'OPTION') {
              localEl.selected = true;
            } else {
              localEl.checked = true;
            }
          });
          selector.updateOptions();
          selector.updateMasterId();
          selector.updateVariantText();
          selector.setDisabled();
        });
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (!fieldsets_array[i]) return;
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            const input = fieldsets_array[i].querySelector(`input[value='${option}']`);
            if (input) input.checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, #product-checkout-form-${this.dataset.section}, #product-checkout-payment-form-${this.dataset.section}, #product-summary-payment-form-${this.dataset.section}, #product-sticky-form-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `preorder-title-price-${this.dataset.section}`, `title-plus-price-${this.dataset.section}`, `select-option-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `deposit-options-${this.dataset.section}`, `checkout-summary-${this.dataset.section}`];
    }

    getSelectedValueIds() {
      const selectedVariantCard = this.querySelector('input[data-value-ids]:checked');
      if (selectedVariantCard) {
        return selectedVariantCard.dataset.valueIds.split(',').map((id) => id.trim()).filter(Boolean);
      }

      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    renderVariantInfo() {
      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      const scrollY = window.scrollY;
      const requestId = ++this.variantInfoRequestId;

      if (this.variantInfoAbortController) {
        this.variantInfoAbortController.abort();
      }

      this.variantInfoAbortController = 'AbortController' in window ? new AbortController() : null;
      const fetchOptions = this.variantInfoAbortController ? { signal: this.variantInfoAbortController.signal } : undefined;

      fetch(`${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`, fetchOptions)
        .then((response) => response.text())
        .then((responseText) => {
          if (requestId !== this.variantInfoRequestId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // 1. Resolve variant from hidden span
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`) || html.querySelector(`[data-selected-variant-section="${this.dataset.section}"]`);
          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
            };
          } else {
            this.currentVariant = null;
          }

          // 2. Sync data-available onto current DOM inputs (drives setDisabled)
          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          // 3. Update price, inventory, sku sections
          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });
          document.querySelectorAll(`preorder-checkout-summary[data-section="${this.dataset.section}"]`).forEach((summary) => {
            if (typeof summary.refresh === 'function') summary.refresh();
          });
          this.initPaymentButtons();

          this.updateOptions();
          this.updateVariantText();
          this.setDisabled();
          this.initDepositOptionCards();

          // 4. Apply updated state
          if (!this.currentVariant) {
            document.querySelectorAll(`product-checkout-summary[data-section="${this.dataset.section}"]`).forEach((summary) => summary.setMainVariant?.(null));
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            this.refreshStickyAddToCart();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            return;
          }
          this.updateVariantInput();
          document.querySelectorAll(`product-checkout-summary[data-section="${this.dataset.section}"]`).forEach((summary) => summary.setMainVariant?.(this.currentVariant.id));
          if (this.updateUrl) this.updateURL();
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.updateMedia();
          this.refreshStickyAddToCart();
          window.scrollTo({ top: scrollY, behavior: 'instant' });
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.error(error);
        })
        .finally(() => {
          if (requestId === this.variantInfoRequestId) {
            this.variantInfoAbortController = null;
          }
        });
    }

    refreshStickyAddToCart() {
      document.querySelectorAll(`product-add-to-cart-sticky[data-section="${this.dataset.section}"]`).forEach((stickyBar) => {
        if (typeof stickyBar.refresh === 'function') {
          stickyBar.refresh(this.currentVariant);
        }
      });
    }

    initPaymentButtons() {
      requestAnimationFrame(() => {
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      });
    }

    getActionButtons() {
      return Array.from(document.querySelectorAll('.single-add-to-cart-button')).filter((submitButton) => {
        return !submitButton.closest('preorder-checkout-summary');
      });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      const productFormWrapper = productForm?.closest('.product-form') || document.querySelector(`product-form[data-section="${this.dataset.section}"]`);
      const productTemplate = productFormWrapper?.getAttribute('template');
      const submitButtons = this.getActionButtons();

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (submitButton.dataset.stickyButtonText) {
            submitButtonText.textContent = submitButton.dataset.stickyButtonText;
          } else if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = this.getActionButtons();
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') return;

      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((opt) => {
            opt.disabled = opt.dataset.available === 'false';
          });
        } else {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.toggle('is-disabled', input.dataset.available === 'false');
          });
        }
      });
      return true;
    }

    initDepositOptionCards() {
      const fieldsets = Array.from(this.querySelectorAll('[data-deposit-option-card]'));
      if (!fieldsets.length) return;

      fieldsets.forEach((fieldset) => {
        const track = fieldset.querySelector('[data-deposit-option-track]');
        const prev = fieldset.querySelector('[data-deposit-option-prev]');
        const next = fieldset.querySelector('[data-deposit-option-next]');
        if (!track || track.dataset.depositOptionInit === 'true') return;

        track.dataset.depositOptionInit = 'true';

        const getStep = () => {
          const card = track.querySelector('label');
          if (!card) {
            return track.clientWidth;
          }
          const style = window.getComputedStyle(track);
          const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
          return card.getBoundingClientRect().width + gap;
        };

        const updateButtons = () => {
          const overflow = track.scrollWidth > track.clientWidth + 1;
          fieldset.classList.toggle('is-scrollable', overflow);
          if (prev) prev.hidden = !overflow || track.scrollLeft <= 1;
          if (next) next.hidden = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        };

        const scrollTrack = (direction) => {
          track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
        };

        if (prev) {
          prev.addEventListener('click', (event) => {
            event.preventDefault();
            scrollTrack(-1);
          });
        }

        if (next) {
          next.addEventListener('click', (event) => {
            event.preventDefault();
            scrollTrack(1);
          });
        }

        track.addEventListener('scroll', updateButtons, { passive: true });
        window.requestAnimationFrame(updateButtons);
      });
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        const imageSetInput = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]');
        if (!imageSetInput) return;
        this.imageSetIndex = imageSetInput.dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
      let setValue = this.getImageSetName(this.options[optionPosition]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('option-product-selector')) {
  class OptionProductSelector extends HTMLElement {
    connectedCallback() {
      this.variants = this.readVariants();
      this.hiddenInput = this.querySelector('[data-addon-selected-variant]');
      this.selectorMode = this.dataset.selectorMode || 'options';
      this.addEventListener('change', this.onChange.bind(this));
      this.update();
    }

    readVariants() {
      const script = this.querySelector('[data-option-product-variants]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent || '[]');
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    onChange() {
      this.update();
    }

    getSelectedOptions() {
      return Array.from(this.querySelectorAll('fieldset[data-addon-option-position]'))
        .sort((a, b) => parseInt(a.dataset.addonOptionPosition, 10) - parseInt(b.dataset.addonOptionPosition, 10))
        .map((fieldset) => fieldset.querySelector('input:checked')?.value || '');
    }

    findVariant(options) {
      return this.variants.find((variant) => {
        return options.every((value, index) => !value || variant.options[index] === value);
      });
    }

    findAvailableVariant(options) {
      return this.variants.find((variant) => {
        return variant.available && options.every((value, index) => !value || variant.options[index] === value);
      });
    }

    update() {
      if (this.selectorMode === 'product-tabs') {
        this.updateProductTabs();
        return;
      }

      let selectedOptions = this.getSelectedOptions();
      let selectedVariant = this.findVariant(selectedOptions);

      if (!selectedVariant || !selectedVariant.available) {
        const availableVariant = this.findAvailableVariant(selectedOptions.slice(0, 1)) || this.findAvailableVariant([]);
        if (availableVariant) {
          this.syncInputsToVariant(availableVariant);
          selectedOptions = this.getSelectedOptions();
          selectedVariant = availableVariant;
        }
      }

      if (this.hiddenInput && selectedVariant) {
        this.hiddenInput.value = selectedVariant.id;
      }
      if (selectedVariant) {
        this.dataset.selectedVariantId = selectedVariant.id;
      }

      this.updateCards(selectedOptions);
      this.dispatchEvent(new CustomEvent('option-product:change', {
        bubbles: true,
        detail: {
          productId: this.dataset.productId,
          variant: selectedVariant || null
        }
      }));
    }

    updateProductTabs() {
      const tabs = Array.from(this.querySelectorAll('[data-addon-product-tab]'));
      let activeTab = tabs.find((input) => input.checked && !input.disabled) || tabs.find((input) => !input.disabled) || tabs[0];

      if (activeTab && !activeTab.checked) activeTab.checked = true;

      const activeProductId = activeTab?.dataset.addonProductId || '';
      let activePanel = null;
      this.querySelectorAll('[data-addon-product-panel]').forEach((panel) => {
        const isActive = panel.dataset.addonProductPanel === activeProductId;
        panel.hidden = !isActive;
        if (isActive) activePanel = panel;
      });

      let selectedInput = activePanel?.querySelector('[data-addon-direct-variant]:checked:not(:disabled)');
      if (!selectedInput) {
        selectedInput = activePanel?.querySelector('[data-addon-direct-variant]:not(:disabled)') || null;
        if (selectedInput) selectedInput.checked = true;
      }

      const selectedVariant = this.variants.find((variant) => String(variant.id) === String(selectedInput?.value)) || null;
      if (this.hiddenInput) this.hiddenInput.value = selectedVariant?.id || '';

      if (selectedVariant) {
        this.dataset.selectedVariantId = selectedVariant.id;
        this.dataset.productId = selectedVariant.product_id || activeProductId;
      } else {
        delete this.dataset.selectedVariantId;
      }

      this.dispatchEvent(new CustomEvent('option-product:change', {
        bubbles: true,
        detail: {
          productId: selectedVariant?.product_id || activeProductId,
          variant: selectedVariant
        }
      }));
    }

    syncInputsToVariant(variant) {
      if (!variant) return;
      variant.options.forEach((value, index) => {
        const position = index + 1;
        const input = this.findOptionInput(position, value);
        if (input) input.checked = true;
      });
    }

    findOptionInput(position, value) {
      return Array.from(this.querySelectorAll(`input[data-addon-option-position="${position}"]`)).find((input) => {
        return input.dataset.addonOptionValue === value;
      });
    }

    updateCards(selectedOptions) {
      this.querySelectorAll('[data-addon-card]').forEach((card) => {
        const fieldset = card.closest('fieldset[data-addon-option-position]');
        const input = card.previousElementSibling;
        if (!fieldset || !input) return;

        const position = parseInt(fieldset.dataset.addonOptionPosition, 10);
        const cardOptions = selectedOptions.slice();
        cardOptions[position - 1] = card.dataset.addonCardValue || input.value;
        const variant = this.findVariant(cardOptions);

        input.disabled = !variant || !variant.available;
        input.classList.toggle('is-disabled', !variant || !variant.available);
        card.classList.toggle('is-disabled', !variant || !variant.available);

        if (!variant) return;

        card.dataset.variantId = variant.id;
        this.updateText(card.querySelector('[data-addon-card-title]'), variant.title);
        this.updateBadge(card, variant.badge);
        this.updateIcon(card.querySelector('[data-addon-card-icon]'), variant);
        this.updatePrice(card, variant);
      });
    }

    updateText(element, text) {
      if (!element) return;
      element.textContent = text || '';
    }

    updateBadge(card, badge) {
      let badgeElement = card.querySelector('[data-addon-card-badge]');
      if (!badge) {
        if (badgeElement) badgeElement.hidden = true;
        return;
      }
      if (!badgeElement) {
        badgeElement = document.createElement('span');
        badgeElement.className = 'option-products__addon-badge';
        badgeElement.dataset.addonCardBadge = '';
        card.prepend(badgeElement);
      }
      badgeElement.hidden = false;
      badgeElement.textContent = badge;
    }

    updateIcon(icon, variant) {
      if (!icon) return;
      if (variant.hex_image) {
        icon.innerHTML = `<img src="${this.escapeAttribute(variant.hex_image)}" alt="" width="90" height="80" loading="lazy">`;
        return;
      }
      if (variant.hex_label) {
        const parts = variant.hex_label.split('|');
        icon.innerHTML = `<span class="option-products__hex"><span class="option-products__hex-num">${this.escapeHtml(parts[0] || '')}</span>${parts[1] ? `<span class="option-products__hex-unit">${this.escapeHtml(parts[1])}</span>` : ''}</span>`;
        return;
      }
      if (variant.image) {
        icon.innerHTML = `<img src="${this.escapeAttribute(variant.image)}" alt="" width="90" height="80" loading="lazy">`;
        return;
      }
      icon.innerHTML = '';
    }

    updatePrice(card, variant) {
      const price = card.querySelector('[data-addon-card-price]');
      if (!price) return;

      const compare = variant.compare_label ? `<span class="option-products__addon-compare" data-addon-card-compare>${this.escapeHtml(variant.compare_label)}</span>` : '';
      const isFree = (variant.price_label || '').toLowerCase() === 'free';
      const valueClasses = [isFree ? 'option-products__addon-free' : '', variant.price_highlight ? 'option-products__addon-primary' : ''].filter(Boolean).join(' ');
      const valueClass = valueClasses ? ` class="${valueClasses}"` : '';
      const value = variant.price_label ? `<span${valueClass} data-addon-card-value-label>${this.escapeHtml(variant.price_label)}</span>` : '';
      const billing = variant.billing_label ? `<span class="option-products__addon-billing" data-addon-card-billing>${this.escapeHtml(variant.billing_label)}</span>` : '';
      price.innerHTML = `${compare}${value}${billing}`;
      price.hidden = !compare && !value && !billing;
    }

    escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[char]);
    }

    escapeAttribute(value) {
      return this.escapeHtml(value).replace(/`/g, '&#096;');
    }
  }

  customElements.define('option-product-selector', OptionProductSelector);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    disconnectedCallback() {
      if (this.flkty) {
        this.flkty.destroy();
      }
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        document.body.classList.add('open-lightbox');
        pswp.listen('firstUpdate', function () {
          pswp.listen('destroy', function () {
            document.body.classList.remove('open-lightbox');
          });
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = this.querySelector('form[data-type="add-to-cart-form"]') || document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) return;
      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput) variantInput.disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer && OverlayManager.isOpen(search_drawer)) {
        OverlayManager.close(search_drawer);
      }
      if (product_drawer && product_drawer.contains(this)) {
        OverlayManager.close(product_drawer);
        if (document.getElementById('Cart-Drawer')) {
          document.getElementById('Cart-Drawer').open();
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/**
 *  @class
 *  @function ProductCheckoutSummary
 */
if (!customElements.get('product-checkout-summary')) {
  class ProductCheckoutSummary extends HTMLElement {
    constructor() {
      super();
      this.addonVariants = new Map();
      this.onProductVariantChange = this.handleProductVariantChange.bind(this);
      this.onOptionProductChange = this.handleOptionProductChange.bind(this);
      this.onProductAddonChange = this.handleProductAddonChange.bind(this);
      this.onSummaryChange = this.handleSummaryChange.bind(this);
      this.onSummaryClick = this.handleSummaryClick.bind(this);
    }

    connectedCallback() {
      this.mainVariants = this.readVariants(this.querySelector('[data-summary-main-variants]'));
      this.mainVariantMap = new Map(this.mainVariants.map((variant) => [String(variant.id), variant]));
      this.quantityInput = this.querySelector('[data-summary-quantity-input]');
      this.addEventListener('change', this.onSummaryChange);
      this.addEventListener('click', this.onSummaryClick);
      document.addEventListener('product:variant-change', this.onProductVariantChange);
      document.addEventListener('option-product:change', this.onOptionProductChange);
      document.addEventListener('change', this.onProductAddonChange);
      requestAnimationFrame(() => this.syncFromPage());
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onSummaryChange);
      this.removeEventListener('click', this.onSummaryClick);
      document.removeEventListener('product:variant-change', this.onProductVariantChange);
      document.removeEventListener('option-product:change', this.onOptionProductChange);
      document.removeEventListener('change', this.onProductAddonChange);
    }

    readVariants(script) {
      if (!script) return [];
      try {
        return JSON.parse(script.textContent || '[]');
      } catch (error) {
        console.error(error);
        return [];
      }
    }

    syncFromPage() {
      const mainInput = document.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
      this.setMainVariant(mainInput?.value || this.dataset.currentMainVariantId, false);
      this.addonVariants.clear();

      document.querySelectorAll(`option-product-selector[data-section="${this.dataset.section}"][data-option-role]`).forEach((selector) => {
        const variants = selector.variants || this.readVariants(selector.querySelector('[data-option-product-variants]'));
        const selectedId = selector.dataset.selectedVariantId || selector.querySelector('[data-addon-selected-variant]')?.value;
        const selectedVariant = variants.find((variant) => String(variant.id) === String(selectedId));
        if (selectedVariant) this.addonVariants.set(selector.dataset.optionRole, selectedVariant);
      });

      this.update();
    }

    setMainVariant(variantOrId, shouldUpdate = true) {
      const variantId = typeof variantOrId === 'object' ? variantOrId?.id : variantOrId;
      const variant = this.mainVariantMap.get(String(variantId));
      if (!variant) {
        this.mainVariant = null;
        this.updateAvailability([]);
        return;
      }

      this.mainVariant = variant;
      this.dataset.currentMainVariantId = variant.id;
      if (shouldUpdate) this.update();
    }

    handleProductVariantChange(event) {
      if (String(event.detail?.sectionId) !== String(this.dataset.section)) return;
      this.setMainVariant(event.detail?.variant?.id);
    }

    handleOptionProductChange(event) {
      const selector = event.target.closest('option-product-selector[data-option-role]');
      if (!selector || String(selector.dataset.section) !== String(this.dataset.section)) return;

      if (event.detail?.variant) {
        this.addonVariants.set(selector.dataset.optionRole, event.detail.variant);
      } else {
        this.addonVariants.delete(selector.dataset.optionRole);
      }
      this.update();
    }

    handleProductAddonChange(event) {
      if (!event.target.matches('[data-addon-product-checkbox], [data-addon-quantity]')) return;
      const addonSection = event.target.closest('[data-product-addons]');
      if (!addonSection || String(addonSection.dataset.section) !== String(this.dataset.section)) return;
      this.update();
    }

    handleSummaryChange(event) {
      if (event.target !== this.quantityInput) return;
      this.update();
    }

    handleSummaryClick(event) {
      const submitButton = event.target.closest('[data-summary-submit]');
      if (!submitButton || !this.contains(submitButton) || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;
      this.addSelectedItems(submitButton.dataset.summarySubmit === 'checkout');
    }

    getSelectedVariants() {
      return [
        this.mainVariant,
        this.addonVariants.get('warranty_product'),
        this.addonVariants.get('app_plan_product')
      ].filter(Boolean);
    }

    getSelectedProductAddons() {
      return Array.from(document.querySelectorAll(`[data-product-addons][data-section="${this.dataset.section}"] [data-addon-product]`))
        .map((item) => {
          const checkbox = item.querySelector('[data-addon-product-checkbox]');
          const quantityInput = item.querySelector('[data-addon-quantity]');
          if (!checkbox?.checked || checkbox.disabled) return null;

          return {
            id: parseInt(item.dataset.variantId || checkbox.dataset.variantId || '0', 10) || 0,
            title: item.dataset.addonTitle || '',
            price: parseInt(item.dataset.addonPrice || '0', 10) || 0,
            compare_at_price: parseInt(item.dataset.addonComparePrice || '0', 10) || 0,
            quantity: Math.max(parseInt(quantityInput?.value || '1', 10) || 1, 1)
          };
        })
        .filter((addon) => addon?.id);
    }

    update() {
      if (!this.mainVariant) return;

      const variants = this.getSelectedVariants();
      const productAddons = this.getSelectedProductAddons();
      const quantity = this.updateQuantityRules(variants);
      this.updateTitles(variants);
      this.updateImage(this.mainVariant);
      this.updateBundleItems(productAddons);
      this.updatePrices(variants, quantity, productAddons);
      this.updateQuantityOutputs(quantity);
      this.updatePaymentForm(quantity);
      this.updateAvailability(variants);
    }

    updateQuantityRules(variants) {
      const minimum = Math.max(...variants.map((variant) => parseInt(variant.quantity_min || '1', 10) || 1), 1);
      const increments = variants.map((variant) => parseInt(variant.quantity_increment || '1', 10) || 1);
      const increment = Math.max(...increments, 1);
      const maximums = variants
        .map((variant) => parseInt(variant.quantity_max || '0', 10) || 0)
        .filter((maximum) => maximum > 0);
      const maximum = maximums.length ? Math.min(...maximums) : 0;
      let quantity = parseInt(this.quantityInput?.value || minimum, 10) || minimum;

      quantity = Math.max(quantity, minimum);
      if (maximum) quantity = Math.min(quantity, maximum);
      quantity = minimum + Math.round((quantity - minimum) / increment) * increment;
      if (maximum) quantity = Math.min(quantity, maximum);

      if (this.quantityInput) {
        this.quantityInput.value = quantity;
        this.quantityInput.min = minimum;
        this.quantityInput.dataset.min = minimum;
        this.quantityInput.step = increment;
        if (maximum) {
          this.quantityInput.max = maximum;
          this.quantityInput.dataset.max = maximum;
        } else {
          this.quantityInput.removeAttribute('max');
          delete this.quantityInput.dataset.max;
        }
        const quantitySelector = this.quantityInput.closest('quantity-selector');
        if (quantitySelector) {
          quantitySelector.step = String(increment);
          if (typeof quantitySelector.validateQtyRules === 'function') quantitySelector.validateQtyRules();
        }
      }

      return quantity;
    }

    updateTitles(variants) {
      const titles = variants
        .map((variant, index) => index === 0 ? (variant.options?.[0] || variant.title) : (variant.title || variant.variant_title))
        .filter((title) => title && title !== 'Default Title');
      const titleElement = this.querySelector('[data-summary-variant-titles]');
      if (titleElement) {
        titleElement.textContent = titles.join(' / ');
        titleElement.hidden = titles.length === 0;
      }
    }

    updateImage(variant) {
      const media = this.querySelector('[data-summary-media]');
      let image = this.querySelector('[data-summary-image]');
      if (media && variant.image_ratio) media.style.setProperty('--summary-media-ratio', variant.image_ratio);
      if (!variant.image) return;

      if (!image && media) {
        image = document.createElement('img');
        image.dataset.summaryImage = '';
        image.loading = 'lazy';
        media.appendChild(image);
      }
      if (image && image.src !== variant.image) image.src = variant.image;
    }

    updateBundleItems(productAddons) {
      const container = this.querySelector('[data-summary-bundle-items]');
      if (!container) return;

      container.innerHTML = productAddons.map((addon) => `
        <div class="product-checkout-summary__bundle-item">
          <span class="product-checkout-summary__bundle-title">${this.escapeHtml(addon.title)} <span class="product-checkout-summary__bundle-price">(${this.formatMoney(addon.price)})</span></span>
          <span class="product-checkout-summary__bundle-quantity">x${addon.quantity}</span>
        </div>
      `).join('');
      container.hidden = productAddons.length === 0;
    }

    updatePrices(variants, quantity, productAddons = []) {
      const unitPrice = variants.reduce((total, variant) => total + (parseInt(variant.price || '0', 10) || 0), 0);
      const unitCompare = variants.reduce((total, variant) => {
        const price = parseInt(variant.price || '0', 10) || 0;
        const compare = parseInt(variant.compare_at_price || '0', 10) || 0;
        return total + Math.max(price, compare);
      }, 0);
      const addonTotal = productAddons.reduce((total, addon) => total + addon.price * addon.quantity, 0);
      const addonCompareTotal = productAddons.reduce((total, addon) => total + Math.max(addon.price, addon.compare_at_price) * addon.quantity, 0);
      const total = unitPrice * quantity + addonTotal;
      const compareTotal = unitCompare * quantity + addonCompareTotal;
      const savings = Math.max(compareTotal - total, 0);
      const totalElement = this.querySelector('[data-summary-total]');
      const compareElement = this.querySelector('[data-summary-compare-total]');
      const savingsElement = this.querySelector('[data-summary-savings]');

      if (totalElement) totalElement.innerHTML = this.formatMoney(total);
      if (compareElement) {
        compareElement.innerHTML = this.formatMoney(compareTotal);
        compareElement.hidden = savings <= 0;
      }
      if (savingsElement) {
        savingsElement.innerHTML = `${this.escapeHtml(this.dataset.savingsLabel || 'Save')} ${this.formatMoney(savings)}`;
        savingsElement.hidden = savings <= 0;
      }
    }

    updateQuantityOutputs(quantity) {
      const productQuantity = this.querySelector('[data-summary-product-quantity]');
      if (productQuantity) productQuantity.textContent = `x${quantity}`;

      const externalQuantity = document.getElementById(`Quantity-${this.dataset.section}`);
      if (externalQuantity && String(externalQuantity.value) !== String(quantity)) {
        externalQuantity.value = quantity;
        externalQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updatePaymentForm(quantity) {
      const variantInput = this.querySelector('[data-summary-payment-variant]');
      const quantityInput = this.querySelector('[data-summary-payment-quantity]');
      if (variantInput) variantInput.value = this.mainVariant.id;
      if (quantityInput) quantityInput.value = quantity;
    }

    updateAvailability(variants) {
      const unavailable = variants.length === 0 || variants.some((variant) => !variant.available);
      this.isAvailable = !unavailable;
      this.querySelectorAll('[data-summary-submit]').forEach((button) => {
        button.disabled = unavailable;
      });
      const paymentForm = this.querySelector('.product-checkout-summary__payment-form');
      if (paymentForm) paymentForm.hidden = unavailable;
    }

    getItems() {
      const quantity = Math.max(parseInt(this.quantityInput?.value || '1', 10) || 1, 1);
      const quantities = new Map();
      this.getSelectedVariants().forEach((variant) => {
        const variantId = String(variant.id);
        quantities.set(variantId, (quantities.get(variantId) || 0) + quantity);
      });
      this.getSelectedProductAddons().forEach((addon) => {
        const variantId = String(addon.id);
        quantities.set(variantId, (quantities.get(variantId) || 0) + addon.quantity);
      });
      return Array.from(quantities, ([id, itemQuantity]) => ({ id: parseInt(id, 10), quantity: itemQuantity }));
    }

    async addSelectedItems(redirectToCheckout) {
      const items = this.getItems();
      if (!items.length) return;

      this.setLoading(true);
      this.showError('');
      try {
        const response = await fetch(this.dataset.cartAddUrl || theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items,
            sections: ['main-cart', 'cart-drawer', 'cart-bubble'],
            sections_url: window.location.pathname
          })
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add these products to cart.');

        if (redirectToCheckout) {
          window.location.href = this.dataset.checkoutUrl || `${window.Shopify?.routes?.root || '/'}checkout`;
          return;
        }

        this.renderCartContents(state);
        dispatchCustomEvent('cart:item-added', { product: state.items?.[0] || state });
      } catch (error) {
        console.error(error);
        this.showError(error.message || 'Unable to add these products to cart.');
      } finally {
        this.setLoading(false);
      }
    }

    renderCartContents(state) {
      if (!state.sections) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }

      [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
      ].forEach((section) => {
        const wrapper = document.getElementById(section.id);
        const html = state.sections[section.section];
        if (!wrapper || !html) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        if (!parsed) return;
        const destination = wrapper.querySelector(section.selector) || wrapper;
        destination.innerHTML = parsed.innerHTML;
      });

      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
    }

    setLoading(loading) {
      this.querySelectorAll('[data-summary-submit]').forEach((button) => {
        button.classList.toggle('loading', loading);
        button.toggleAttribute('aria-disabled', loading);
        button.disabled = loading || !this.isAvailable;
      });
    }

    showError(message) {
      const errorElement = this.querySelector('[data-summary-error]');
      if (!errorElement) return;
      errorElement.textContent = message;
      errorElement.hidden = !message;
    }

    formatMoney(cents) {
      if (typeof formatMoney === 'function') return formatMoney(cents, this.dataset.moneyFormat);
      return `$${(cents / 100).toFixed(2)}`;
    }

    escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[char]);
    }
  }

  customElements.define('product-checkout-summary', ProductCheckoutSummary);
}


/**
 *  @class
 *  @function PreorderCheckoutSummary
 */
if (!customElements.get('preorder-checkout-summary')) {
  class PreorderCheckoutSummary extends HTMLElement {
    constructor() {
      super();
      this.onQuantityChange = this.updateQuantity.bind(this);
    }

    connectedCallback() {
      this.refresh();
    }

    refresh() {
      this.bindQuantityInput();
      this.updateQuantity();
    }

    bindQuantityInput() {
      const nextInput = document.getElementById(`Quantity-${this.dataset.section}`);
      if (this.quantityInput === nextInput) return;

      if (this.quantityInput) {
        this.quantityInput.removeEventListener('change', this.onQuantityChange);
        this.quantityInput.removeEventListener('input', this.onQuantityChange);
      }

      this.quantityInput = nextInput;

      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', this.onQuantityChange);
        this.quantityInput.addEventListener('input', this.onQuantityChange);
      }
    }

    updateQuantity() {
      const quantity = Math.max(parseInt(this.quantityInput?.value || '1', 10) || 1, 1);
      const quantityInputs = this.querySelectorAll('[data-summary-quantity]');
      const quantityText = this.querySelector('[data-summary-qty]');
      const totalText = this.querySelector('[data-summary-total]');
      const unlockedText = this.querySelector('[data-summary-unlocked]');
      const unitPrice = parseInt(totalText?.dataset.unitPrice || this.dataset.unitPrice || '0', 10) || 0;
      const unlockedValue = parseInt(unlockedText?.dataset.unlockedValue || '0', 10) || 0;

      quantityInputs.forEach((quantityInput) => {
        quantityInput.value = quantity;
      });
      if (quantityText) quantityText.textContent = `x${quantity}`;
      if (totalText) totalText.innerHTML = this.formatMoney(unitPrice * quantity);
      if (unlockedText) {
        const totalUnlocked = unlockedValue * quantity;
        const unlockedLabel = unlockedText.querySelector('span:last-child');
        if (unlockedLabel) unlockedLabel.textContent = `$${totalUnlocked} Value Unlocked!`;
        unlockedText.hidden = totalUnlocked <= 0;
      }
    }

    formatMoney(cents) {
      if (typeof formatMoney === 'function') {
        return formatMoney(cents, this.dataset.moneyFormat);
      }

      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  customElements.define('preorder-checkout-summary', PreorderCheckoutSummary);
}


/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.onQuantityChange = this.syncQuantity.bind(this);
    }
    connectedCallback() {
      this.titleElement = this.querySelector('.product-add-to-cart-sticky__title');
      this.loadTitleMap();
      this.updateTitleFromVariantInput();
      this.setupObservers();
      this.setupToggle();
      this.setupQuantitySync();
    }
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.tl) {
        this.tl.kill();
      }
      if (this.quantityInput) {
        this.quantityInput.removeEventListener('change', this.onQuantityChange);
        this.quantityInput.removeEventListener('input', this.onQuantityChange);
      }
    }
    refresh(variant) {
      this.currentVariant = variant;
      this.loadTitleMap();
      this.updateTitle(variant?.id);
      this.setupObservers();
      this.setupQuantitySync();
    }
    loadTitleMap() {
      const titleMap = this.querySelector('[data-sticky-title-map]');

      if (!titleMap) {
        this.stickyTitleMap = null;
        return;
      }

      try {
        this.stickyTitleMap = JSON.parse(titleMap.textContent);
      } catch (e) {
        this.stickyTitleMap = null;
      }
    }
    updateTitleFromVariantInput() {
      const variantInput = this.querySelector('[name="id"]') || document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="id"]');
      this.updateTitle(variantInput?.value);
    }
    updateTitle(variantId) {
      if (!this.titleElement || !this.stickyTitleMap) return;

      const title = this.stickyTitleMap.titles?.[String(variantId)] || this.stickyTitleMap.productTitle;
      if (title) {
        this.titleElement.textContent = title;
      }
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (!button || !content) return;

      if (this.animations_enabled) {
        this.tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        this.tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', () => {
          this.tl.reversed() ? this.tl.play() : this.tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this;
      let form = document.getElementById(`product-form-${this.dataset.section}`) || document.getElementById(`product-checkout-form-${this.dataset.section}`),
        footer = document.getElementById('footer');

      if (this.observer) {
        this.observer.disconnect();
      }

      if (!form || !('IntersectionObserver' in window)) {
        this.classList.add('sticky--visible');
        return;
      }

      this.observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (footer && entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && boundingRect.bottom <= 0) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        });
      _this.formPassed = form.getBoundingClientRect().bottom <= 0;
      this.updateVisibilityFromCurrentPosition(form, footer);
      this.observer.observe(form);
      if (footer) {
        this.observer.observe(footer);
      }
    }
    updateVisibilityFromCurrentPosition(form, footer) {
      const footerRect = footer?.getBoundingClientRect();
      const footerVisible = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;

      if (this.formPassed && !footerVisible) {
        this.classList.add('sticky--visible');
      } else {
        this.classList.remove('sticky--visible');
      }
    }
    setupQuantitySync() {
      if (this.quantityInput) {
        this.quantityInput.removeEventListener('change', this.onQuantityChange);
        this.quantityInput.removeEventListener('input', this.onQuantityChange);
      }

      this.quantityInput = document.getElementById(`Quantity-${this.dataset.section}`);
      this.stickyQuantityInput = this.querySelector('[data-sticky-quantity]');

      if (!this.quantityInput || !this.stickyQuantityInput) return;

      this.syncQuantity();
      this.quantityInput.addEventListener('change', this.onQuantityChange);
      this.quantityInput.addEventListener('input', this.onQuantityChange);
    }
    syncQuantity() {
      if (!this.quantityInput || !this.stickyQuantityInput) return;
      this.stickyQuantityInput.value = Math.max(parseInt(this.quantityInput.value || '1', 10) || 1, 1);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.buttons.toggleActiveClass(i);
          OverlayManager.open(this.drawer);
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
